import type { Game } from "@engine/core/Game";

export interface Scene {
  readonly name: string;
  enter(game: Game): void | Promise<void>;
  exit(game: Game): void | Promise<void>;
}

export class SceneManager {
  private current: Scene | undefined;

  constructor(private game: Game) {}

  async go(scene: Scene): Promise<void> {
    if (this.current) {
      await this.current.exit(this.game);
      this.game.events.emit("scene:exit", { name: this.current.name });
    }
    this.current = scene;
    await scene.enter(this.game);
    this.game.events.emit("scene:enter", { name: scene.name });
  }

  async clear(): Promise<void> {
    if (this.current) {
      await this.current.exit(this.game);
      this.game.events.emit("scene:exit", { name: this.current.name });
      this.current = undefined;
    }
  }

  get currentName(): string | undefined {
    return this.current?.name;
  }
}
